var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-300 py-4"},[_vm._v(" © Медицинская практика 2021")])}
var staticRenderFns = []

export { render, staticRenderFns }